import {
	fanTokenOfferingApi,
	useCustomErrorManagementForFanTokenOffering
} from '@capsicum/features/fan-token-offering/shared';
import { useQuery } from '@tanstack/react-query';

import type {
	FanTokenOfferingCostEstimate,
	PostVoteTokenOfferingBuyByVoteTokenOfferingIdData,
	PostVoteTokenOfferingBuyByVoteTokenOfferingIdParams
} from '@capsicum/common';
import type { AxiosError } from 'axios';

export const useOfferingPostPurchaseQueryKey = (params: PostVoteTokenOfferingBuyByVoteTokenOfferingIdParams) => [
	'offeringPostPurchase',
	params?.voteTokenOfferingId
];

/**
 * Query that call the FTO buy endpoint with payload.
 *
 * @returns {PostVoteTokenOfferingBuyByVoteTokenOfferingIdData} the react query
 */
export const useOfferingPostPurchaseQuery = (
	params: PostVoteTokenOfferingBuyByVoteTokenOfferingIdParams,
	payloadData: FanTokenOfferingCostEstimate['payload']
) => {
	const { manageFanTokenOfferingInterceptor } = useCustomErrorManagementForFanTokenOffering();

	return useQuery<PostVoteTokenOfferingBuyByVoteTokenOfferingIdData>({
		enabled: !!params.voteTokenOfferingId && !!payloadData.paidAmount,
		queryFn: async () => {
			return (await fanTokenOfferingApi).postVoteTokenOfferingBuyByVoteTokenOfferingId(params, payloadData, {
				customErrorInterceptor: (error: AxiosError<unknown, any> | Error) =>
					manageFanTokenOfferingInterceptor(error as AxiosError<unknown, any>)
			});
		},
		// eslint-disable-next-line @tanstack/query/exhaustive-deps
		queryKey: useOfferingPostPurchaseQueryKey(params)
	});
};
